<template>
	<div @click.self="$emit('stopWCScanner')" class="fixed inset-0 bg-black/50 backdrop-blur-md flex items-center justify-center z-50">
		<div class="popup-bg text-[var(--popup-text-color)] rounded-lg p-6 w-11/12 md:w-2/3 lg:w-1/2 xl:w-2/5 relative">
			<button @click="$emit('stopWCScanner')" class="absolute top-4 right-4 text-[var(--accent-color)]">
				<img :src="(currentTheme === 'dark' || currentTheme === 'navy') ? darkX : lightX" alt="Close" class="w-3 h-3"/>
			</button>

			<h2 class="text-xl font-archivomedium mb-4 text-center text-[var(--popup-text-color)]">
				Scan WalletConnect QR
			</h2>

			<div class="flex flex-col items-center h-72 md:h-80 rounded-xl">
				<QrcodeStream @decode="$emit('decode', $event)" @init="$emit('init', $event)" class="w-full h-full h-60 md:h-80"></QrcodeStream>
			</div>

			<p class="mt-4 text-sm md:text-md font-archivolight text-center text-[var(--secondary-text-color)]">
				Position the QR code in front of your camera to scan.
			</p>

			<button @click="$emit('stopWCScanner')" class="mt-4 font-archivoregular w-full bg-transparent text-[var(--accent-color)] border border-[var(--accent-color)] py-2 rounded-full hover:bg-[var(--accent-color)] hover:text-[var(--hover-text-color)] transition duration-100 shadow-inner">
				Cancel
			</button>
		</div>
	</div>
</template>

<script setup>
	import { QrcodeStream } from 'vue3-qrcode-reader';
	import lightX from '../assets/X.png';
	import darkX from '../assets/XWhite.png';

	const props = defineProps({
		currentTheme: { type: String, required: true }
	});

	const emit = defineEmits([
		'decode',
		'init',
		'stopWCScanner'
	]);
</script>

<style scoped>
  .popup-bg {
    background: var(--popup-bg-color);
  }
</style>
